// 公共URL

const dev = '/api'
// const prod = "http://127.0.0.1:8888/marinecircle/api/";
const prod = 'https://www.marinecircle.com/api/'

export default {
  dev,
  prod
}
